import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSpinnerComponent } from 'ngx-spinner';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet, NgxSpinnerComponent],
  template: ` <ngx-spinner
      name="rwe"
      bdColor="rgba(0,0,0,0.4)"
      size="medium"
      color="#0a58ca"
      type="ball-clip-rotate-multiple"
      [fullScreen]="true"
    ></ngx-spinner>
    <router-outlet></router-outlet>`,
})
export class ApplicationComponent {
  title = 'tsolife-resident-portal';
}
